<div class="py-3 px-5">
  <div class="mat-headline-small mb-2">Change Password</div>
  <p class="mb-3">
    Strong passwords include things such as numbers, a variety of uppercase & lowercase letters, and symbols
  </p>
  <form #passwordForm="ngForm">
    <mat-form-field class="w-100">
      <mat-label>Current Password</mat-label>
      <input
        matInput
        type="password"
        name="password"
        autocomplete="current-password"
        [(ngModel)]="formData.currentPassword"
        required
      />
    </mat-form-field>
    <auth-new-password [formData]="formData" />
    <button matButton="filled" [disabled]="passwordForm.invalid" (click)="submitPasswordChange()">Change</button>
  </form>
</div>
